import React, { createContext, useContext, useState, ReactNode } from 'react'

interface LoadingContextType {
  loading: boolean
  message: string | null
  setLoading: (isLoading: boolean, message?: string) => void
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined)

interface LoadingProviderProps {
  children: ReactNode
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
  const [loading, setLoadingState] = useState<boolean>(false)
  const [message, setMessage] = useState<string | null>(null)

  const setLoading = (isLoading: boolean, msg?: string) => {
    setLoadingState(isLoading)
    setMessage(msg || null)
  }

  return (
    <LoadingContext.Provider value={{ loading, message, setLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}

export const useLoading = () => {
  const context = useContext(LoadingContext)
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider')
  }
  return context
}
